import { connect } from 'react-redux';
import { getCurrentUser, getCanEnableToggleMatureContent, getTierСount, } from '../../../publicSession/selectors';
import { toggleMature, toggleTheme } from '../../../publicSession/actions';
import { userLogoutButtonClicked } from '../../redux/actions';
var mapStateToProps = function (state) { return ({
    currentUser: getCurrentUser(state),
    canEnableMatureContent: getCanEnableToggleMatureContent(state),
    hasSubscriptions: getTierСount(state) > 0,
}); };
var mapDispatchToProps = {
    toggleTheme: toggleTheme,
    toggleMature: toggleMature,
    onUserLogoutButtonClicked: userLogoutButtonClicked,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=UserMenu.container.js.map